import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

import Navbar from '@/components/aside/Navbar.vue';
import Banner from '@/components/main/Banner.vue';
import BottomCarousel from '@/components/main/BottomCarousel.vue';
import Videos from '@/components/main/Videos.vue';
import Share from '@/components/modal/Share.vue';
import { storeToRefs } from 'pinia';
import { useTab } from '@/store';
import { Tab } from '@/types/enums';

export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

const { currentTab } = storeToRefs(useTab());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Navbar),
    _createElementVNode("main", null, [
      (_unref(currentTab) === _unref(Tab).Home)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(Banner),
            _createVNode(BottomCarousel),
            _createVNode(Share)
          ], 64))
        : (_openBlock(), _createBlock(Videos, { key: 1 }))
    ])
  ], 64))
}
}

})